import useAccountView from './useAccountView'

export default function useHelperPin() {
  const {
    accountView: { helperPin },
    accountViewLoading: helperPinLoading,
    handleChangeAccount,
  } = useAccountView()

  const handleChangeHelperPin = (value) => {
    handleChangeAccount([helperPin.asAccountItem(value)])
  }

  return {
    helperPin: helperPin.value,
    helperPinLoading,
    handleChangeHelperPin,
  }
}
